<template>
    <el-dialog
      :title="title"
      :visible.sync="isDialogVisible"
      width="80%"
      @close="handleClose"
    >
      <div>
        <slot>
          <span>默认内容</span>
        </slot>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          @click="cancel" 
          style="background: #00AFAF;color: #fff;"
          round
          >
          关闭
        </el-button>
        <el-button type="primary" @click="confirm" v-show="false" >确定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  export default {
    props: {
      isDialogVisible: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        default: '对话框'
      }
    },
    methods: {
      handleClose() {
        this.$emit('update:isVisible', false);
      },
      cancel() {
        this.$emit('update:isVisible', false);
        this.$emit('cancel');
      },
      confirm() {
        this.$emit('confirm');
      }
    }
  };
  </script>
  
  <style scoped>
  /* 这里可以添加特定于该组件的样式 */
  </style>
  